// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fS","text":"fT","subText":"fU","toggleContainer":"fV","checked":"fW"};